import { useSelector } from 'react-redux';

import { chatModel } from '../model';
import { ConversationState } from '../model/types';
import { ChatBotApplySuggestionsBlock } from './ChatBotApplySuggestionsBlock';
import { ChatBotCancelStreamBlock } from './ChatBotCancelStreamBlock';
import { ChatBotContent } from './ChatBotContent';
import { ChatBotHeader } from './ChatBotHeader';
import { ChatBotInput } from './ChatBotInput';
import { ChatBotLabel } from './ChatBotLabel';

export const ChatBotMain = () => {
  const conversationState = useSelector(
    chatModel.selectors.selectConversationState
  );

  return (
    <>
      <ChatBotHeader />
      <ChatBotContent />
      <div className="mt-auto flex flex-col gap-y-3">
        {(conversationState === ConversationState.Idle ||
          conversationState === ConversationState.Retry) && <ChatBotInput />}
        {conversationState === ConversationState.Streaming && (
          <ChatBotCancelStreamBlock />
        )}
        {conversationState === ConversationState.Suggestion && (
          <ChatBotApplySuggestionsBlock />
        )}
        <ChatBotLabel />
      </div>
    </>
  );
};
